// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isUndefined } from 'lodash';

// Utils
import { getColorCssValue, getIsLowContrastColorSwatch } from '../../../../../../common/colors/colorHelper';

// Components
import Button from '../../../../../components/buttons/Button';

import { COLOR_POPUP_MODE } from './colorPopupConstants';

// Styles
import './ColorButton.scss';
import '../ColorComboButton.scss';

const ColorButton = ({
    color,
    secondaryColor,
    isActive,
    setColor,
    selectedType,
    selectedStatus,
    isContextMenu,
    className,
    colorPopupMode,
    isDarkModeTheme,
    allowColorCombos,
}) => {
    const onColorClick = (event) => {
        const colorName = isUndefined(color && color.name) ? color : color.name;
        // if colorCombos are allowed and there is a secondary color, then set that color otherwise set to null
        const secondary = (allowColorCombos ? secondaryColor : null) || null;

        setColor && setColor(colorName, secondary);
    };

    const colorCss = color && color.css ? color.css : getColorCssValue(color);

    const classes = classNames('ColorButton', className, selectedType, selectedStatus, colorPopupMode, {
        'color-combination': !!secondaryColor,
        active: isActive,
        'no-color': !colorCss,
        'low-contrast-color': getIsLowContrastColorSwatch({
            color: colorCss,
            isDarkModeTheme,
        }),
        'high-contrast-color': getIsLowContrastColorSwatch({
            color: colorCss,
            isDarkModeTheme: !isDarkModeTheme,
        }),
        'remove-color': !colorCss && colorPopupMode === COLOR_POPUP_MODE.COLOR_BAR,
    });

    return (
        <Button
            className={classes}
            style={{ '--ui-color-button-background': colorCss }}
            onClickFn={onColorClick}
            onContextMenu={isContextMenu && onColorClick}
            onMouseUp={isContextMenu && onColorClick}
        >
            <div className="secondary-color-container">
                <div className="secondary-color" style={{ backgroundColor: secondaryColor }} />
            </div>
            <div className="selection-border" />
        </Button>
    );
};

ColorButton.propTypes = {
    selectedType: PropTypes.string,
    selectedStatus: PropTypes.string,
    className: PropTypes.string,
    colorPopupMode: PropTypes.string,
    color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    secondaryColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isActive: PropTypes.bool,
    isContextMenu: PropTypes.bool,
    isDarkModeTheme: PropTypes.bool,
    setColor: PropTypes.func,
    disabled: PropTypes.bool,
    allowColorCombos: PropTypes.bool,
};

export default ColorButton;
